// The babel polyfill for ES6 features such as Object.assign()
import 'core-js/stable';
import 'regenerator-runtime/runtime';

